import React from 'react'
import {
    StyledIconEmail,
    StyledProfileEmailButton,
} from '../../buttons/ProfileEmailButton/ProfileEmailButton.styled'

export interface ProfileEmailButtonProps {
    className?: string
    email: string
    text: string
    url?: string
    title?: string
}

const getBody = (text: string, url?: string, title?: string) => {
    if (!url || !title) {
        return ''
    }

    const bodyText = `Dear ${text},\n\nIn reference to:\n${title}\n${url}\n\nPlease type your message here...`

    return `&body=${encodeURIComponent(bodyText)}`
}

export const ProfileEmailButton: React.FC<ProfileEmailButtonProps> = ({
    className,
    email,
    text,
    url,
    title,
}) => {
    if (!email) {
        return null
    }

    const body = getBody(text, url, title)
    const mailto = `mailto:${email}?subject=Website%20Enquiry%20for%20${text}${body}`

    return (
        <StyledProfileEmailButton className={className} to={mailto}>
            <StyledIconEmail title="Email" /> {text}
        </StyledProfileEmailButton>
    )
}
ProfileEmailButton.displayName = 'ProfileEmailButton'
